const STATUS_POINT = {
  red: 4,
  yellow: 3,
  blue: 2
}

const EXPIRED_STATUS = '期限切れ'

const getStatusPoint = (status) => STATUS_POINT[status] || 1

export const itemHistoryProcess = (items) => {
  if (!items || items.length === 0) return []

  const expiredItems = new Map()
  const activeItems = new Map()

  items.forEach((item) => {
    const key = item.item_id

    if (item.expired_type === EXPIRED_STATUS) {
      if (expiredItems.has(key)) {
        const existing = expiredItems.get(key)

        existing.amount += item.amount

        if (item.id < existing.id) {
          existing.id = item.id
        }
      } else {
        expiredItems.set(key, { ...item })
      }

      return
    }

    if (activeItems.has(key)) {
      const existing = activeItems.get(key)
      existing.amount += item.amount

      if (getStatusPoint(item.expired_type) > getStatusPoint(existing.expired_type)) {
        existing.expired_type = item.expired_type
      }

      if (item.id < existing.id) {
        existing.id = item.id
      }
    } else {
      activeItems.set(key, { ...item })
    }
  })

  return [...activeItems.values(), ...expiredItems.values()].sort((a, b) => a.id - b.id)
}
